// The editor's interactive preview frame, and only that — not the Shopify embed,
// not the Live Preview tab, both of which run against real APIs. Read once at load:
// the router drops the query string on navigation, and non-React callers need the
// answer. Never use isEmbedded() for this, which is also true for the Shopify embed.
import { PREVIEW_PARAM, SubdomainType } from '@/constants'

const PREVIEW_CLASS = 'is-preview'

function readSubdomainType(): SubdomainType | null {
  if (typeof window === 'undefined') {
    return null
  }
  const raw = new URLSearchParams(window.location.search).get(PREVIEW_PARAM)
  if (raw == null || raw === '') {
    return null
  }
  const value = Number(raw)
  if (!Number.isInteger(value) || !Object.values(SubdomainType).includes(value)) {
    return null
  }
  return value as SubdomainType
}

const subdomainType = readSubdomainType()

if (subdomainType != null && typeof document !== 'undefined') {
  document.documentElement.classList.add(PREVIEW_CLASS)
}

export function isInteractivePreviewMode(): boolean {
  return subdomainType != null
}

export function getPreviewSubdomainType(): SubdomainType | null {
  return subdomainType
}

export function createMemoryStorage(): Storage {
  const map = new Map<string, string>()
  return {
    get length() {
      return map.size
    },
    key(index: number) {
      return Array.from(map.keys())[index] ?? null
    },
    getItem(key: string) {
      return map.has(key) ? (map.get(key) as string) : null
    },
    setItem(key: string, value: string) {
      map.set(key, String(value))
    },
    removeItem(key: string) {
      map.delete(key)
    },
    clear() {
      map.clear()
    },
  }
}
